import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import AdminServices from "../services/AdminServices";
import { SidebarContext } from "../context/SidebarContext";
import { notifyError, notifySuccess } from "../utils/toast";
import { AdminContext } from "../context/AdminContext";

const useAdminSettingsSubmit = (id) => {
  const {dispatch} = useContext(AdminContext)
  const { isDrawerOpen, setIsUpdate } = useContext(SidebarContext);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    AdminServices.updateAppSettings(data)
      .then((res) => {
        setIsUpdate(true);
        notifySuccess("Admin Updated Successfully!");
      })
      .catch((err) => notifyError(err.message));
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      AdminServices.getAppSettings(id)
        .then((res) => {
          setLoading(false);
          if (res) {
            var data = res;
            setValue("stripepublickey", data.stripepublickey);
            setValue("stripeSecretKey", data.stripeSecretKey);
            setValue("oneSignalAppID", data.oneSignalAppID);
            setValue("currency", data.currency);
            setValue("commission", data.commission);
            setValue("agoraAppID", data.agoraAppID);
            setValue("AGORA_CERT", data.AGORA_CERT);
            setValue("iosVersion", data.iosVersion);
            setValue("androidVersion", data.androidVersion);
            dispatch({ type: "SETTINGS", payload: data });
          }
        })
        .catch((err) => {
          setLoading(false);
          notifyError("There is a server error!");
        });
    }
  }, [id, setValue, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    loading,
  };
};

export default useAdminSettingsSubmit;
